export default __webpack_public_path__ + "static/media/trash-dark.f610c19f.svg";